import React from 'react';

const TypographyExample = ({ level, size, weight, lineHeight, example, className }) => {
  return (
    <div className="p-4 rounded-lg bg-card border border-border">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3">
        <div>
          <span className="text-xs text-muted-foreground block mb-1">Level</span>
          <span className="text-sm font-medium text-foreground">{level}</span>
        </div>
        <div>
          <span className="text-xs text-muted-foreground block mb-1">Size / Weight</span>
          <span className="text-sm font-medium text-foreground">{size} / {weight}</span>
        </div>
        <div>
          <span className="text-xs text-muted-foreground block mb-1">Line Height</span>
          <span className="text-sm font-medium text-foreground">{lineHeight}</span>
        </div>
      </div>
      <div className="pt-3 border-t border-border">
        <p className={className} style={{ color: 'var(--color-foreground)' }}>{example}</p>
      </div>
    </div>
  );
};

export default TypographyExample;